import { render, staticRenderFns } from "./WithdrawTypes.vue?vue&type=template&id=5465e517&"
import script from "./WithdrawTypes.vue?vue&type=script&lang=js&"
export * from "./WithdrawTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports